import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'SYSTEM',
    entityName: 'TABLE_VIEW',
});

const initialState = {
    ...crudInitialState,
    deletedTableView: {},
    deleting: false,
    saving: false
};
const reducer = (state = initialState, action) => {
    const newState = crudReducer(state, action);
    if (newState !== null) {
        return newState;
    }
    switch (action.type) {
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};
export default reducer;
